import { instructorList, instructorCourseList } from "constants/instructor";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getInstructorList = async (
  dispatch,
  pageNum,
  filter,
) => {
  try {
    const res = await api.instructor_list(pageNum, filter);
    dispatch({ type: instructorList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: instructorList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

// add instructor
export const addInstructor = async (bodyData) => {
  try {
    const res = await api.add_instructor(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get instructor detail by id
export const getInstructorDetailById = async (id) => {
  try {
    const res = await api.get_instructor_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit instructor
export const editInstructor = async (id, bodyData) => {
  try {
    const res = await api.edit_instructor(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// // get courses list for trainer login 
export const getInstructorCourseList = async (dispatch, pageNum, searchString) => {
  try {
    const res = await api.instructor_courses(pageNum, searchString);
    dispatch({ type: instructorCourseList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: instructorCourseList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
// get Instructor profile 
export const getInstructorProfileDetails = async () => {
  try {
    const res = await api.get_instructor_profile_details();
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
// update instructor profile
export const updateInstructorProfileDetails = async (bodyData) => {
  try {
    const res = await api.update_instructor_profile_details(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};


 
